import { Switch } from "antd";

const navigateToTemplate = (navigate, record) =>
  navigate("/manage-email-template", {
    state: {
      manageData: {
        id: record?.id,
        templateName: record?.templateName,
        emailBody: record?.emailBody,
        emailBodySpanish: record?.emailBodySpanish,
        emailSubject: record?.emailSubject,
        emailSubjectSpanish: record?.emailSubjectSpanish,
        eventType: record?.eventType,
        enabled: record?.enabled,
        code: record?.code,
        createdAt: record?.createdAt,
        modifiedAt: record?.modifiedAt,
      },
    },
  });

export const emailColumns = (
  navigate,
  handleSwitchToggle,
  switchStates = {},
  options = {},
) => [
  {
    title: "Template Name",
    key: "templateName",
    dataIndex: "templateName",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date) => date || "-",
  },
  {
    title: <div style={{ textAlign: "center", width: "100%" }}>Status</div>,
    key: "status",
    width: 135,
    align: "center",
    render: (_, record) => (
      <Switch
        className={`switches${options.isViewOnly ? " group-view-only-switch" : ""}`}
        checked={!!switchStates[record.id]}
        onChange={(checked) => handleSwitchToggle(record, checked)}
        disabled={options.isViewOnly}
      />
    ),
  },
  {
    title: <div style={{ textAlign: "center", width: "100%" }}>Actions</div>,
    dataIndex: "action",
    key: "action",
    width: 135,
    align: "center",
    render: (_, record) => {
      if (!options.showView && !options.showManage) {
        return null;
      }

      return (
        <div className="action-icons">
          <div>
            {options.showManage && (
              <button
                className="manage"
                onClick={() => navigateToTemplate(navigate, record)}
              >
                Manage
              </button>
            )}
            {options.showView && (
              <button
                className="manage"
                onClick={() => navigateToTemplate(navigate, record)}
              >
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
